<template>
  <div>
    <layout-one>
      <el-form :model="form" label-width="180px" :inline="true" ref="form">
        <div class="section">
          <h4>选择课程</h4>
          <div class="sectionBox">
            <el-form-item label="课程名称" prop="courseId">
              <el-select v-model="form.courseId" placeholder="请选择" filterable>
                <el-option
                  v-for="item in courseList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="sectionBox">
            <el-form-item label="设置参数" label-width="180px">
              <div style="color:#409EFF;">试题格式转换的同时是否同时输出以下参数，请勾选：</div>
              <el-checkbox-group v-model="itemIdList">
                <el-checkbox label="7" class="examType">试题解析</el-checkbox>
                <el-checkbox label="8" class="examType">试题难度</el-checkbox>
                <el-checkbox label="6" class="examType" v-if="false">知识点</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </div>
          <div style="margin-top: -50px;">
            <el-form-item label="参数说明" label-width="180px">
                <ul>
                    <li style="margin-top:30px; color: red;">1）勾选后，系统仅针对文档中缺失所选参数的题目进行补充。若所选参数在原文档中已存在，则保留原始数据，不做修改</li>
                    <li style="color: red;">2）勾选的参数对本次上传的所有文档生效</li>
                </ul>
            </el-form-item>
          </div>
        </div>
        <div class="section mt20">
          <h4>标准格式设置</h4>
          <div class="sectionBox">
            <el-form-item label="设置试题标准格式" prop="defaultPromptContent">
              <el-switch
                v-model="form.promptFlag"
                :active-value="1"
                :inactive-value="0">
              </el-switch>
              <ots-editor
                class="editor"
                v-model="defaultPromptContent"
                v-if="form.promptFlag == 1"
              />
            </el-form-item>
          </div>
        </div>
        <div class="section mt20">
          <h4>上传文件</h4>
          <div class="sectionBox">
            <el-form-item>
              <div class="stationBox">
                <el-form-item label="上传文件" v-model="uploadFileForm.file" label-width="110px">
                  <ots-upload-file :httpRequest="fileFormData" fileType="doc,docx" />
                  <div style="display: flex;"><el-button round type="primary" @click="uploadFileFn" :disabled="isloading">确定上传</el-button><div style="margin-left: 10px; color: #F56C6C;" v-if="isloading"><i class="el-icon-loading"></i>&nbsp;文件上传中...</div></div>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="已上传文件" label-width="180px" v-if="isUploaded">
                    <div v-for="(file, index) in uploadedFiles" :key="index" class="file-item">
                        <span>{{ file.name }} <i class="el-icon-delete-solid" style="cursor: pointer;" @click="removeFile(index,file.id)"></i></span>
                    </div>
                </el-form-item>
              </div>
              <div style="margin-top: -20px;">
                <el-form-item label="上传说明" label-width="180px">
                    <ul>
                        <li style="margin-top:30px;">1）只能上传doc、docx格式文件</li>
                        <li>2）文件总大小不超过10M</li>
                        <li>3）文档中不能包含图片、音视频等</li>
                        <li style="color: red;">4）请将文档按照每 10 页进行分割，确保每个 10 页的区间内题目完整，不存在题目跨页的情况</li>
                        <li style="color: red;">5）上传时请确认文档中每道题的题型与OTS该门课程下设置的题型一致</li>
                    </ul>
                </el-form-item>
              </div>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </layout-one>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import {
    uploadQuestionFileFn,
    taskSaveFn,
} from '@/http/modules/baseSet/standardTask'
import { getSelectCourse } from "@/http/modules/baseSet/course";

export default {
  name: 'standardTaskAdd',
  data() {
    return {
        courseList: [],
        itemIdList: [],
        defaultPromptContent: "<p style='font-size: 12px;'>样例：</p><p style='font-size: 12px;'>请根据以下格式为我识别所上传试题：</p><p style='font-size: 12px;'>序号格式 ：1.&nbsp;&nbsp; 1、</p><p style='font-size: 12px;'>题干格式：My name ______ Lucy.</p><p style='font-size: 12px;'>选项格式：A. B.C.D./A、B、C、D、</p>",
        uploadedFiles: [],
        isUploaded:false,
        form: {
            courseId: "",
            fileIds: "",
            itemIds: "",
            promptFlag: 0,
            promptContent: "",
        },
        uploadFileForm: {
            file: "",
        },
        saveMethods: "submitForm",
        backMethods: "goBack",
        isloading: false,
    }
  },
  created() {
    this.initData();
  },
  mounted() {
    this.SAVE_PAGE_THIS(this);
  },
  methods: {
    ...mapMutations(["SAVE_PAGE_THIS"]),
    initData() {
      getSelectCourse().then(res => {
        this.courseList = res.data;
      })
    },
    fileFormData(val) {
      this.uploadFileForm.file = val.file;
    },
    async uploadFileFn() {
      this.isloading = true;
      if (!this.uploadFileForm.file) {
        this.$message.error("请选择文件")
        return
      }
      const fd = new FormData()
      for (let item in this.uploadFileForm) {
        fd.append(item, this.uploadFileForm[item])
      }
      const { code, data } = await uploadQuestionFileFn(fd);
      if (code == 1) {
        this.$message.success("上传成功");
        this.uploadedFiles.push({
            id: data.id,
            name: this.uploadFileForm.file.name,
        });
        this.form.fileIds += data.id + ",";
        this.isUploaded = true;
        this.isloading = false;
      }
    },
    async removeFile(index,id) {
      this.uploadedFiles.splice(index, 1);
      let arr = this.form.fileIds.split(",");
      let filterArr = arr.filter(item => item != id);
      this.form.fileIds = filterArr.join(",");
      if(this.uploadedFiles.length == 0){
        this.isUploaded = false;
      }
    },
    submitForm() {
      if(this.form.courseId == ""){
        this.$message.error("请选择课程");
        return;
      }
      if(this.form.fileIds == ""){
        this.$message.error("请上传文件");
        return;
      }
      if(this.form.promptFlag == 1 && this.defaultPromptContent == ""){
        this.$message.error("请输入提示内容");
        return;
      }
      //参数
      this.form.itemIds = this.itemIdList.join(",");
      //文件id去掉最后一个逗号
      this.form.fileIds = this.form.fileIds.slice(0, -1);
      if(this.form.promptFlag == 1 && this.defaultPromptContent){
        this.form.promptContent = this.defaultPromptContent;
      }
      taskSaveFn(this.form).then(res => {
        if (res.code == 1) {
          this.$message.success("添加成功");
          this.$router.push({ name: "standardTask" });
        }
      })
    },
    goBack(){
      this.$router.push({ name: "standardTask" });
    }
  },
}
</script>

<style lang="less" scoped>
.file-item {
  display: flex;
  align-items: center;
}
.el-form-item.examBegin {
  /deep/ .el-form-item__content {
    width: 180px;
    .el-input {
      width: 98px;
      margin-right: 4px;
    }
    .el-input__inner {
      width: 98px;
      padding: 8px 8px 8px 8px !important;
    }
  }
}

.section {
  border-bottom: 1px solid #f1f2f5;
  h4 {
    margin-bottom: 30px;
  }
  .sectionBox {
    .lang {
      width: 512px;
    }
    .examType {
      width: 120px;
      margin-right: 16px;
    }
  }
  .stationBox {
    width: 1000px;
    max-height: 300px;
    overflow-y: auto;
    padding: 0px 70px;
    border-radius: 8px;
  }
  .editor {
    width: 800px;
  }
  .unEditor {
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    border-radius: 3px;
    padding: 8px;
    width: 800px;
    height: 200px;
    overflow: auto;
    line-height: 1.5;
    overflow-wrap: break-word;
  }
  /deep/ .el-form-item {
    margin-bottom: 30px !important;
  }
  /deep/ .el-checkbox {
    width: 360px;
    overflow: hidden;
    white-space: nowrap;
  }
  li {
    line-height: 35px;
    color:#909399;
  }
}
</style>
